import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AnalyticsViewContext, provideAnalyticsViewContext } from '@recruitee/analytics';
import { DetachedRouterOutlet } from '@recruitee/common';

import { ProductOrderPersistenceService } from '../../../services/product-order-persistence.service';
import { ProductOrderTrackingService } from '../../../services/product-order-tracking.service';
import { ProductOrderConfigService } from '../config/product-order-config.service';

@Component({
  selector: 'rt-product-order',
  templateUrl: './product-order.component.html',
  styleUrls: ['./product-order.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideAnalyticsViewContext(AnalyticsViewContext.Billing)],
  providers: [
    ProductOrderConfigService,
    ProductOrderTrackingService,
    ProductOrderPersistenceService,
  ],
  standalone: true,
  imports: [DetachedRouterOutlet],
})
export class ProductOrderComponent {
  constructor(
    private config: ProductOrderConfigService,
    private productOrderTrackingService: ProductOrderTrackingService,
    private persistenceService: ProductOrderPersistenceService,
  ) {}

  public ngOnInit() {
    this.persistenceService.clear();
  }

  public ngOnDestroy() {
    this.persistenceService.clear();
  }
}
